/* SnackShark: illustrative, image-backed mix preview. No inventory or pricing logic. */
(function (scope, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (scope && scope.document && !scope.SnackSharkCandyPreview) scope.SnackSharkCandyPreview = api;
})(typeof window === 'object' ? window : null, function () {
  'use strict';

  var instances = new WeakMap();
  var stylesheetId = 'ss-candy-preview-styles';
  var shapes = {
    bottle: { ratio: 0.56, bounds: [0.19, 0.29, 0.62, 0.64], clip: 'polygon(34% 2%,66% 2%,66% 16%,75% 24%,82% 30%,84% 36%,84% 94%,80% 98%,20% 98%,16% 94%,16% 36%,18% 30%,25% 24%,34% 16%)' },
    bag: { ratio: 0.76, bounds: [0.15, 0.15, 0.70, 0.75], clip: 'polygon(13% 3%,87% 3%,86% 22%,95% 92%,90% 98%,10% 98%,5% 92%,14% 22%)' },
    cup: { ratio: 0.91, bounds: [0.12, 0.05, 0.76, 0.18], clip: 'polygon(5% 5%,95% 5%,86% 92%,80% 98%,20% 98%,14% 92%)' },
    heart: { ratio: 1.06, bounds: [0.10, 0.13, 0.80, 0.74], clip: 'polygon(50% 96%,9% 57%,2% 37%,4% 20%,15% 7%,31% 3%,43% 9%,50% 19%,57% 9%,69% 3%,85% 7%,96% 20%,98% 37%,91% 57%)' },
    number: { ratio: 0.70, bounds: [0.05, 0.05, 0.90, 0.90], clip: 'inset(1% round 12%)' },
    letter: { ratio: 0.88, bounds: [0.05, 0.05, 0.90, 0.90], clip: 'inset(1% round 12%)' }
  };
  var defaultLabels = {
    empty: 'Noch keine Sorten gewählt',
    preview: 'Illustrative Mix-Vorschau',
    productPhotos: 'Illustration mit Produktfotos',
    symbolic: 'Symbolische Verpackung',
    missing: 'Für einige Sorten fehlt ein Vorschaubild',
    packageMissing: 'Verpackungsbild nicht verfügbar',
    maskLoading: 'Füllvorschau lädt …',
    maskMissing: 'Füllvorschau nicht verfügbar'
  };
  var styles = [
    '.ss-candy-preview{position:relative;width:100%;height:100%;min-height:0;overflow:hidden;isolation:isolate;contain:layout paint;color:inherit;font:inherit}',
    '.ss-candy-preview__scene{position:absolute;inset:8% 0 30px;display:flex;align-items:center;justify-content:center;pointer-events:none}',
    '.ss-candy-preview__vessel{position:relative;width:0;height:0;max-width:none;flex:0 0 auto;isolation:isolate;overflow:visible}',
    '.ss-candy-preview__shell,.ss-candy-preview__content,.ss-candy-preview__depth,.ss-candy-preview__image{position:absolute;inset:0;width:100%;height:100%;margin:0;pointer-events:none}',
    '.ss-candy-preview__shell{z-index:0;background:linear-gradient(110deg,rgba(229,240,247,.65),rgba(255,255,255,.22) 42%,rgba(215,234,245,.64));box-shadow:inset 0 0 0 2px rgba(83,72,91,.2)}',
    '.ss-candy-preview__image{z-index:0;display:block;object-fit:fill}',
    '.ss-candy-preview__content{z-index:1;overflow:hidden;mask-size:100% 100%;mask-repeat:no-repeat;mask-position:center;-webkit-mask-size:100% 100%;-webkit-mask-repeat:no-repeat;-webkit-mask-position:center}',
    '.ss-candy-preview__depth{z-index:1;overflow:hidden;pointer-events:none}',
    '.ss-candy-preview__depth-piece{position:absolute;display:block;max-width:none;object-fit:contain;pointer-events:none;transform:translate(-50%,-50%) rotate(var(--ss-piece-angle,0deg));filter:brightness(.86) drop-shadow(0 1px 1px #35203248);opacity:.94}',
    '.ss-candy-preview__image--front{z-index:2}',
    '.ss-candy-preview__flight{position:absolute;inset:0;z-index:4;overflow:visible;pointer-events:none}',
    '.ss-candy-preview__sprite{position:absolute;display:block;max-width:none;margin:0;height:auto;aspect-ratio:1;object-fit:contain;pointer-events:none;opacity:0;filter:drop-shadow(0 var(--ss-piece-shadow,1px) 1px #35203250) drop-shadow(1px 2px 2px #35203225);transition:opacity 180ms ease;transform:translate(-50%,-50%) rotate(var(--ss-piece-angle,0deg)) scale(1)}',
    '.ss-candy-preview__sprite.is-visible{opacity:1;transform:translate(-50%,-50%) rotate(var(--ss-piece-angle,0deg)) scale(1)}',
    '.ss-candy-preview__sprite.is-in-flight{transition:none;will-change:transform,left,top;filter:drop-shadow(0 5px 4px #482b3b24)}',
    '.ss-candy-preview__lid{z-index:5;transform-origin:var(--ss-lid-origin,50% 16%);filter:drop-shadow(0 2px 2px #39243220)}',
    '.ss-candy-preview__status{position:absolute;inset:auto 4px 0;margin:0;min-height:26px;display:flex;align-items:center;justify-content:center;text-align:center;font:inherit;font-size:11px;line-height:1.2;color:inherit;opacity:.78}',
    '.ss-candy-preview [hidden]{display:none!important}',
    '.ss-candy-preview[data-reduced-motion="true"] .ss-candy-preview__sprite{transition:none!important}',
    '@media(prefers-reduced-motion:reduce){.ss-candy-preview__sprite{transition:none!important}}'
  ].join('\n');

  function number(value, fallback) {
    var parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }
  function clamp(value, low, high) { return Math.min(high, Math.max(low, value)); }
  function text(value, fallback) { return typeof value === 'string' ? value.slice(0, 300) : fallback; }
  function hash(value) {
    var result = 2166136261;
    for (var index = 0; index < value.length; index += 1) result = Math.imul(result ^ value.charCodeAt(index), 16777619);
    // Avalanche similar per-SKU keys, otherwise adjacent pieces form ingredient layers.
    result ^= result >>> 16;
    result = Math.imul(result, 0x7feb352d);
    result ^= result >>> 15;
    result = Math.imul(result, 0x846ca68b);
    result ^= result >>> 16;
    return result >>> 0;
  }
  function random(key) { return hash(key) / 4294967296; }
  function imageValue(value) {
    if (typeof value === 'string') return value;
    return value && typeof value === 'object' ? value.url || value.src || '' : '';
  }
  function safeUrl(value, origin) {
    var raw = typeof value === 'string' ? value.trim() : '';
    if (!raw || raw.length > 4096 || /[\u0000-\u0020\u007f\\]/.test(raw)) return '';
    if (!/^(https?:\/\/|\/)/i.test(raw)) return '';
    try {
      var url = new URL(raw, origin || 'https://preview.invalid');
      if (!/^https?:$/.test(url.protocol) || url.username || url.password) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function firstImage(values, origin) {
    for (var index = 0; index < values.length; index += 1) {
      var candidate = safeUrl(imageValue(values[index]), origin);
      if (candidate) return candidate;
    }
    return '';
  }

  // Accept either API items or the existing configurator Map<id, { product, qty }>.
  function toItems(source) {
    var entries = source instanceof Map ? Array.from(source.values()) : Array.isArray(source) ? source : [];
    return entries.slice(0, 5000).map(function (entry) {
      entry = entry && typeof entry === 'object' ? entry : {};
      var product = entry.product || entry;
      var erp = product._erp || {};
      return {
        id: String(entry.id || erp.sku || product.id || product.sku || product.title || ''),
        quantity: entry.quantity != null ? entry.quantity : entry.qty,
        title: text(entry.title || product.title, ''),
        preview_image_url: entry.preview_image_url || erp.preview_image_url || product.preview_image_url,
        image_url: entry.image_url || erp.image_url || product.image_url,
        image: entry.image || product.featured_image || (Array.isArray(product.images) ? product.images[0] : '')
      };
    });
  }
  function normalizeItems(source, origin) {
    var byKey = new Map();
    toItems(source).forEach(function (item) {
      var quantity = clamp(number(item.quantity, 0), 0, 1000000);
      if (!quantity) return;
      var preview = firstImage([item.preview_image_url], origin);
      var url = preview || firstImage([item.image_url, item.image], origin);
      var id = (item.id || url || 'missing-image').slice(0, 300);
      var key = JSON.stringify([id, url]);
      if (byKey.has(key)) {
        byKey.get(key).quantity = Math.min(1000000, byKey.get(key).quantity + quantity);
      } else {
        byKey.set(key, { key: key, id: id, title: item.title, quantity: quantity, url: url, productPhoto: !!url && !preview });
      }
    });
    return Array.from(byKey.values()).sort(function (a, b) { return a.key < b.key ? -1 : a.key > b.key ? 1 : 0; });
  }
  function validPolygon(value) {
    return Array.isArray(value) && value.length >= 3 && value.length <= 64
      && value.every(function (point) { return Array.isArray(point) && point.length === 2 && point.every(function (n) { return typeof n === 'number' && Number.isFinite(n) && n >= 0 && n <= 1; }); })
      ? value.map(function (point) { return point.slice(); }) : null;
  }
  function polygonClip(points, inverse, holes) {
    if (!points) return '';
    var path = points.slice();
    if (inverse) path = [[0, 0], [1, 0], [1, 1], [0, 1], [0, 0]].concat(path, [path[0], [0, 0]]);
    (holes || []).forEach(function (hole) { path = path.concat([path[0], hole[0]], hole.slice(1), [hole[0], path[0]]); });
    return 'polygon(' + (inverse || holes && holes.length ? 'evenodd,' : '') + path.map(function (point) { return (point[0] * 100).toFixed(2) + '% ' + (point[1] * 100).toFixed(2) + '%'; }).join(',') + ')';
  }
  function normalizePackage(raw, origin) {
    raw = raw && typeof raw === 'object' ? raw : {};
    var shape = Object.prototype.hasOwnProperty.call(shapes, raw.shape) ? raw.shape : 'bag';
    var defaults = shapes[shape];
    var opaque = typeof raw.opaque === 'boolean' ? raw.opaque : shape === 'cup';
    var incoming = raw.fill_bounds && typeof raw.fill_bounds === 'object' ? raw.fill_bounds : {};
    var x = clamp(number(incoming.x, defaults.bounds[0]), 0, 0.99);
    var y = clamp(number(incoming.y, defaults.bounds[1]), 0, 0.99);
    var width = clamp(number(incoming.width, defaults.bounds[2]), 0.01, 1 - x);
    var height = clamp(number(incoming.height, defaults.bounds[3]), 0.01, 1 - y);
    // An opaque vessel exposes only its opening, never a fictitious transparent wall.
    if (opaque && !raw.fill_bounds) { x = 0.12; y = 0.05; width = 0.76; height = 0.18; }
    var glyph = typeof raw.glyph === 'string' && /^[A-Za-zÄÖÜäöüß0-9]{1,3}$/.test(raw.glyph) ? raw.glyph : '';
    var image = safeUrl(imageValue(raw.image_url), origin);
    var front = safeUrl(imageValue(raw.front_image_url), origin);
    var openFront = safeUrl(imageValue(raw.open_front_image_url), origin);
    var openBoundsRaw = raw.open_front_bounds || { x: 0, y: 0, width: 1, height: 1 };
    var openBoundsValid = openBoundsRaw && ['x', 'y', 'width', 'height'].every(function (key) { return typeof openBoundsRaw[key] === 'number' && Number.isFinite(openBoundsRaw[key]); })
      && openBoundsRaw.x === 0 && openBoundsRaw.y === 0 && openBoundsRaw.width === 1 && openBoundsRaw.height > 0 && openBoundsRaw.height <= 1;
    // Theme-authored geometry only: numeric coordinates, never executable SVG/CSS.
    var polygon = validPolygon(raw.fill_polygon), frontCutout = validPolygon(raw.front_cutout_polygon);
    var holes = Array.isArray(raw.fill_holes) ? raw.fill_holes.slice(0, 4).map(validPolygon).filter(Boolean) : [];
    var silhouette = validPolygon(raw.silhouette_polygon);
    var silhouetteHoles = Array.isArray(raw.silhouette_holes) ? raw.silhouette_holes.slice(0,4).map(validPolygon).filter(Boolean) : [];
    var imageClip = polygonClip(silhouette, false, silhouetteHoles);
    var authoredFrontClip = silhouette && frontCutout ? polygonClip(silhouette, false, silhouetteHoles.concat([frontCutout], holes)) : polygonClip(frontCutout, true, holes);
    var depthPolygon = front && polygon ? validPolygon(raw.depth_polygon) : null;
    var depthOffset = raw.depth_offset && typeof raw.depth_offset === 'object' ? raw.depth_offset : {};
    var depthFrontOpacity = clamp(number(raw.depth_front_opacity, 1), .12, 1);
    var surfacePolygon = front && polygon ? validPolygon(raw.surface_polygon) : null;
    var surfaceFrontOpacity = clamp(number(raw.surface_front_opacity, 1), .04, 1);
    var frontDetailPolygon = front && surfacePolygon ? validPolygon(raw.front_detail_polygon) : null;
    var layout = raw.layout === 'tray' || raw.layout !== 'upright' && (opaque || /^(heart|number|letter)$/.test(shape)) ? 'tray' : 'upright';
    var lid = raw.lid && typeof raw.lid === 'object' ? raw.lid : null;
    var lidBounds = lid && lid.bounds, lidOpen = lid && lid.open || {};
    var lidUrl = lid && safeUrl(imageValue(lid.image_url || front || image), origin);
    var validLidGeometry = lidUrl && shape === 'bottle' && lidBounds && ['x', 'y', 'width', 'height'].every(function (key) { return typeof lidBounds[key] === 'number' && Number.isFinite(lidBounds[key]); })
      && lidBounds.x >= 0 && lidBounds.y >= 0 && lidBounds.width > 0 && lidBounds.height > 0 && lidBounds.x + lidBounds.width <= 1 && lidBounds.y + lidBounds.height <= .5;
    var validLid = validLidGeometry && openFront && openBoundsValid && openBoundsRaw.height >= lidBounds.y + lidBounds.height;
    var opening = raw.opening && typeof raw.opening === 'object' ? raw.opening : {};
    var sticker = raw.sticker && typeof raw.sticker === 'object' ? raw.sticker : null;
    var stickerUrl = sticker && safeUrl(imageValue(sticker.logo_url), origin);
    var stickerBounds = sticker && sticker.bounds;
    var validSticker = shape === 'bottle' && stickerUrl && stickerBounds && ['x', 'y', 'width', 'height'].every(function (key) { return typeof stickerBounds[key] === 'number' && Number.isFinite(stickerBounds[key]); })
      && stickerBounds.x >= 0 && stickerBounds.y >= 0 && stickerBounds.width > 0 && stickerBounds.height > 0 && stickerBounds.x + stickerBounds.width <= 1 && stickerBounds.y + stickerBounds.height <= 1;
    var openingY = shape === 'bottle' ? Math.max(.025, y - .11) : Math.max(.025, y + .025);
    return {
      id: text(raw.id, shape), shape: shape, opaque: opaque, glyph: glyph,
      imageUrl: image, frontUrl: front,
      sticker: validSticker ? { logoUrl: stickerUrl, bounds: { x: stickerBounds.x, y: stickerBounds.y, width: stickerBounds.width, height: stickerBounds.height } } : null,
      openFrontUrl: openFront && openBoundsValid ? openFront : '',
      openFrontBounds: openBoundsValid ? { x: 0, y: 0, width: 1, height: openBoundsRaw.height } : null,
      openingPending: !!validLidGeometry && !validLid,
      maskUrl: safeUrl(imageValue(raw.mask_url || raw.fill_mask_url), origin),
      fillClip: polygonClip(polygon, false, holes), fillPolygon: polygon, fillHoles: holes, imageClip: imageClip, frontBaseClip: authoredFrontClip,
      // An authored cavity cutout is the union silhouette, not a second XOR
      // hole: overlapping top/depth holes used to restore a white wedge.
      frontClip: frontCutout ? authoredFrontClip : depthPolygon && depthFrontOpacity < 1 ? polygonClip(depthPolygon, true) : imageClip, layout: layout,
      arrangement: raw.arrangement === 'grouped' && /^(number|letter)$/.test(shape) ? 'grouped' : 'mixed',
      edgeOcclusion: raw.edge_occlusion === true && !!front && !!polygon,
      depthPolygon: depthPolygon, depthClip: polygonClip(depthPolygon),
      depthMode: depthPolygon && raw.depth_mode === 'contour' ? 'contour' : 'offset',
      depthFrontOpacity: depthFrontOpacity,
      depthPieceScale: clamp(number(raw.depth_piece_scale, 1), .8, 1.4),
      surfacePolygon: surfacePolygon, surfaceClip: polygonClip(surfacePolygon), surfaceFrontOpacity: surfaceFrontOpacity,
      frontDetailClip: polygonClip(frontDetailPolygon),
      depthOffset: { x: clamp(number(depthOffset.x, 0), -.15, .15), y: clamp(number(depthOffset.y, 0), 0, .18) },
      finishAnchors: polygon && Array.isArray(raw.finish_anchors) ? raw.finish_anchors.slice(0, 8).filter(function (point) {
        return Array.isArray(point) && point.length === 3 && point.every(function (n) { return typeof n === 'number' && Number.isFinite(n); })
          && point[0] >= x && point[0] <= x + width && point[1] >= y && point[1] <= y + height
          && point[2] >= .02 && point[2] <= .20 && insidePolygon(point[0], point[1], polygon);
      }).map(function (point) { return point.slice(); }) : [],
      spriteBudget: Math.round(clamp(number(raw.max_sprites, 48), 1, 96)),
      pieceScale: clamp(number(raw.piece_scale, 1), .55, 1.4),
      lid: validLid ? { imageUrl: lidUrl, bounds: { x: lidBounds.x, y: lidBounds.y, width: lidBounds.width, height: lidBounds.height },
        open: { x: clamp(number(lidOpen.x, .1), -.35, .35), y: clamp(number(lidOpen.y, -.1), -.35, 0), angle: clamp(number(lidOpen.angle, -18), -60, 60) } } : null,
      ratio: clamp(number(raw.aspect_ratio, defaults.ratio), 0.2, 3),
      bounds: { x: x, y: y, width: width, height: height },
      opening: { x: clamp(number(opening.x, x + width / 2), .05, .95), y: clamp(number(opening.y, openingY), .015, .9) },
      clip: defaults.clip,
      capacity: Math.max(0, number(raw.capacity, 0)),
      symbolic: !image && !front,
      // A custom asset without a supplied mask uses its bounds, not a mismatched generic silhouette.
      genericClip: !image && !front
    };
  }
  var seatCache = new Map();
  function insidePolygon(x, y, polygon) {
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var a = polygon[i], b = polygon[j];
      if ((a[1] > y) !== (b[1] > y) && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) inside = !inside;
    }
    return inside;
  }
  function edgeDistance(x, y, polygon, ratio) {
    var result = Infinity;
    polygon.forEach(function (a, i) {
      var b = polygon[(i + 1) % polygon.length], dx = (b[0] - a[0]) * ratio, dy = b[1] - a[1];
      var px = (x - a[0]) * ratio, py = y - a[1];
      var along = clamp((px * dx + py * dy) / Math.max(1e-12, dx * dx + dy * dy), 0, 1);
      result = Math.min(result, Math.hypot(px - dx * along, py - dy * along));
    });
    return result;
  }
  function verticalSpan(x, polygon) {
    var intersections = [];
    polygon.forEach(function (a, index) {
      var b = polygon[(index + 1) % polygon.length];
      if ((a[0] <= x && b[0] > x) || (b[0] <= x && a[0] > x)) intersections.push(a[1] + (x - a[0]) * (b[1] - a[1]) / (b[0] - a[0]));
    });
    if (intersections.length < 2) return null;
    return { top: Math.min.apply(null, intersections), bottom: Math.max.apply(null, intersections) };
  }
  function nearestEdgeAngle(x, y, polygon, ratio) {
    var closest = Infinity, angle = 0;
    polygon.forEach(function (a, index) {
      var b = polygon[(index + 1) % polygon.length], dx = (b[0] - a[0]) * ratio, dy = b[1] - a[1];
      var px = (x - a[0]) * ratio, py = y - a[1];
      var along = clamp((px * dx + py * dy) / Math.max(1e-12, dx * dx + dy * dy), 0, 1);
      var distance = Math.hypot(px - along * dx, py - along * dy);
      if (distance < closest) { closest = distance; angle = Math.atan2(dy, dx) * 180 / Math.PI; }
    });
    return angle;
  }
  function fitFootprint(seat, angle, ratio, bounds, aspect) {
    var radians = angle * Math.PI / 180, cosine = Math.cos(radians), sine = Math.sin(radians);
    var desiredWidth = seat.width * Math.sqrt(aspect), desiredHeight = seat.width * ratio / Math.sqrt(aspect);
    function fits(scale) {
      var halfWidth = desiredWidth * ratio * scale / 2, halfHeight = desiredHeight * scale / 2;
      // Check the full boundary, not only four corners: a concave tray notch
      // may cross an otherwise valid rectangle. Keep the tiny bounce inside.
      for (var edge = 0; edge < 4; edge += 1) {
        for (var step = 0; step <= 4; step += 1) {
          var t = -1 + step / 2;
          var dx = (edge === 0 ? t : edge === 1 ? 1 : edge === 2 ? -t : -1) * halfWidth;
          var dy = (edge === 0 ? -1 : edge === 1 ? t : edge === 2 ? 1 : -t) * halfHeight;
          var x = seat.x + (dx * cosine - dy * sine) / ratio, y = seat.y + dx * sine + dy * cosine;
          if (x < bounds.x || x > bounds.x + bounds.width || y < bounds.y || y > bounds.y + bounds.height || !insidePolygon(x, y, seat.polygon) || (seat.holes || []).some(function(hole) { return insidePolygon(x,y,hole); })) return false;
        }
      }
      return true;
    }
    var high = 1.04, low = 0;
    if (fits(high)) return { width: desiredWidth, height: desiredHeight };
    for (var iteration = 0; iteration < 9; iteration += 1) {
      var middle = (low + high) / 2;
      if (fits(middle)) low = middle; else high = middle;
    }
    return { width: desiredWidth * low / 1.04, height: desiredHeight * low / 1.04 };
  }
  function layoutSeats(descriptor, budget, seed) {
    var cacheKey = JSON.stringify([descriptor, budget, seed]);
    if (seatCache.has(cacheKey)) return seatCache.get(cacheKey);
    var b = descriptor.bounds, ratio = descriptor.ratio;
    var polygon = descriptor.fillPolygon;
    if (!polygon && descriptor.genericClip && descriptor.clip.indexOf('polygon(') === 0) {
      polygon = descriptor.clip.slice(8, -1).split(',').map(function (pair) { return pair.trim().split(/\s+/).map(function (n) { return parseFloat(n) / 100; }); });
    }
    if (!polygon) polygon = [[b.x, b.y], [b.x + b.width, b.y], [b.x + b.width, b.y + b.height], [b.x, b.y + b.height]];
    var pool = [], resolution = 28;
    for (var row = 0; row < resolution; row += 1) {
      for (var col = 0; col < resolution; col += 1) {
        var x = b.x + b.width * (col + .5 + (random(seed + ':gridx:' + row + ':' + col) - .5) * .35) / resolution;
        var y = b.y + b.height * (row + .5 + (random(seed + ':gridy:' + row + ':' + col) - .5) * .35) / resolution;
        if (!insidePolygon(x, y, polygon) || descriptor.fillHoles.some(function(hole) { return insidePolygon(x,y,hole); })) continue;
        var clearance = Math.min(edgeDistance(x, y, polygon, ratio), (x - b.x) * ratio, (b.x + b.width - x) * ratio, y - b.y, b.y + b.height - y);
        descriptor.fillHoles.forEach(function(hole) { clearance = Math.min(clearance, edgeDistance(x,y,hole,ratio)); });
        if (clearance > .001) pool.push({ x: x, y: y, clearance: clearance, nearest: Infinity });
      }
    }
    var area = pool.length / (resolution * resolution) * b.width * ratio * b.height;
    var diameter = Math.sqrt(area / Math.max(1, budget)) * (descriptor.layout === 'tray' ? 2.18 : 1.70) * descriptor.pieceScale;
    if (descriptor.layout === 'tray') diameter = Math.min(diameter, .105 * ratio * descriptor.pieceScale);
    var chosen = [];
    // Weighted farthest-point seats cover concave wells instead of filling the
    // empty rectangle around a heart/number. The pool is independent of items.
    for (var index = 0; index < budget && pool.length; index += 1) {
      var winner = 0, best = -1;
      pool.forEach(function (point, i) {
        var centrality = clamp(point.clearance / Math.max(.001, diameter * .55), .06, 1);
        var score = index ? point.nearest * centrality : point.clearance;
        if (score > best) { best = score; winner = i; }
      });
      var point = pool.splice(winner, 1)[0];
      // Upright stacks keep conservative circular clearance. Tray pieces can
      // turn along a real wall: their complete rotated footprint is checked
      // later, avoiding the artificial empty moat of circumscribed circles.
      point.width = (descriptor.layout === 'tray' ? diameter : Math.min(diameter, point.clearance * 1.37)) / ratio;
      point.edgeAngle = nearestEdgeAngle(point.x, point.y, polygon, ratio);
      point.polygon = polygon;
      point.holes = descriptor.fillHoles;
      point.id = index;
      chosen.push(point);
      pool.forEach(function (candidate) { candidate.nearest = Math.min(candidate.nearest, Math.pow((candidate.x - point.x) * ratio, 2) + Math.pow(candidate.y - point.y, 2)); });
    }
    if (descriptor.layout === 'upright') chosen.sort(function (a, b) { return b.y - a.y || a.x - b.x; });
    var finishing = [];
    descriptor.finishAnchors.slice(0, chosen.length).forEach(function (anchor) {
      var nearest = 0, distance = Infinity;
      chosen.forEach(function (point, i) {
        var candidate = Math.pow((point.x - anchor[0]) * ratio, 2) + Math.pow(point.y - anchor[1], 2);
        if (candidate < distance) { nearest = i; distance = candidate; }
      });
      var point = chosen.splice(nearest, 1)[0];
      point.x = anchor[0]; point.y = anchor[1]; point.width = anchor[2]; point.finish = true;
      point.clearance = edgeDistance(point.x, point.y, polygon, ratio);
      point.edgeAngle = nearestEdgeAngle(point.x, point.y, polygon, ratio);
      finishing.push(point);
    });
    // Reserved seats replace nearby existing ones, never increase the budget.
    // Being last in this stable plan makes the neck/tip fill with the last
    // portion, while ordinary earlier pieces never jump when it is added.
    chosen = chosen.concat(finishing);
    if (descriptor.arrangement === 'grouped') {
      // Consistent reading-order rows follow the actual cavity, including the
      // separate arms of a number. Seats and angles do not depend on SKUs.
      var rowHeight = Math.max(.018, diameter * .56);
      chosen.sort(function (a, b) {
        return Math.floor((a.y - descriptor.bounds.y) / rowHeight) - Math.floor((b.y - descriptor.bounds.y) / rowHeight) || a.x - b.x || a.y - b.y;
      });
    }
    if (seatCache.size >= 32) seatCache.delete(seatCache.keys().next().value);
    seatCache.set(cacheKey, chosen);
    return chosen;
  }
  function allocate(items, count) {
    if (!items.length || !count) return [];
    var total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var allocation = items.map(function (item) {
      var target = item.quantity / total * count;
      return { item: item, count: Math.floor(target), fraction: target % 1 };
    });
    var remaining = count - allocation.reduce(function (sum, item) { return sum + item.count; }, 0);
    allocation.slice().sort(function (a, b) { return b.fraction - a.fraction || (a.item.key < b.item.key ? -1 : 1); }).forEach(function (entry) {
      if (remaining > 0) { entry.count += 1; remaining -= 1; }
    });
    return allocation;
  }
  function createPlan(options, previous) {
    options = options || {};
    var descriptor = normalizePackage(options.package, options.origin);
    var items = normalizeItems(options.items, options.origin);
    var visible = items.filter(function (item) { return !!item.url; });
    var total = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var visibleQuantity = visible.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var capacity = Math.max(0, number(options.capacity, descriptor.capacity));
    var ratio = total ? capacity > 0 ? Math.min(total / capacity, 1) : 1 : 0;
    var maxSprites = Math.round(clamp(number(options.maxSprites, descriptor.spriteBudget), 1, 96));
    var count = total && visibleQuantity ? Math.min(maxSprites, Math.max(1, Math.round(maxSprites * ratio * visibleQuantity / total))) : 0;
    var seed = String(options.seed == null ? descriptor.id : options.seed).slice(0, 300);
    var layoutKey = JSON.stringify([descriptor, maxSprites, seed]);
    var prior = previous && previous.layoutKey === layoutKey ? previous : null;
    var particles = [];
    var allocation = allocate(visible, count);
    // Largest-remainder rounding must not remove a stationary piece from an
    // unchanged ingredient merely because a new SKU now sorts before it.
    if (prior && total >= prior.totalQuantity) {
      var oldCounts = new Map(), oldQuantities = new Map(prior.items.map(function (item) { return [item.key, item.quantity]; }));
      prior.particles.forEach(function (particle) { var key = particle.itemKey; oldCounts.set(key, (oldCounts.get(key) || 0) + 1); });
      allocation.forEach(function (entry) {
        var target = oldQuantities.get(entry.item.key) <= entry.item.quantity ? oldCounts.get(entry.item.key) || 0 : 0;
        while (entry.count < target) {
          var donor = allocation.find(function (other) { return other !== entry && other.count > Math.max(1, oldCounts.get(other.item.key) || 0); });
          if (!donor) break;
          donor.count -= 1; entry.count += 1;
        }
      });
    }
    allocation.forEach(function (entry) {
      for (var index = 0; index < entry.count; index += 1) {
        var key = entry.item.key + ':' + index;
        particles.push({ key: key, itemKey: entry.item.key, id: entry.item.id, url: entry.item.url, productPhoto: entry.item.productPhoto, order: hash(seed + ':order:' + key) });
      }
    });
    if (descriptor.arrangement !== 'grouped') particles.sort(function (a, b) { return a.order - b.order || (a.key < b.key ? -1 : 1); });
    var seats = layoutSeats(descriptor, maxSprites, seed), usedSeats = new Set();
    var allowFinish = count > seats.filter(function (seat) { return !seat.finish; }).length;
    var oldParticles = new Map(prior ? prior.particles.map(function (particle) { return [particle.key, particle]; }) : []);
    particles.forEach(function (particle) {
      var old = oldParticles.get(particle.key);
      if (old && seats.some(function (seat) { return seat.id === old.seat && (!seat.finish || allowFinish); })) { particle.seat = old.seat; usedSeats.add(old.seat); }
    });
    particles.forEach(function (particle) {
      var key = seed + ':' + particle.key;
      var seat = particle.seat != null ? seats.find(function (candidate) { return candidate.id === particle.seat; }) : seats.find(function (candidate) { return !usedSeats.has(candidate.id); });
      if (descriptor.arrangement === 'grouped' && particle.seat == null && prior) {
        var peers = particles.filter(function (other) { return other !== particle && other.itemKey === particle.itemKey && other.seat != null; });
        if (peers.length) {
          var bestDistance = Infinity;
          seats.forEach(function (candidate) {
            if (usedSeats.has(candidate.id)) return;
            var distance = Math.min.apply(null, peers.map(function (peer) {
              var peerSeat = seats.find(function (point) { return point.id === peer.seat; });
              return Math.pow((candidate.x - peerSeat.x) * descriptor.ratio, 2) + Math.pow(candidate.y - peerSeat.y, 2);
            }));
            if (distance < bestDistance) { bestDistance = distance; seat = candidate; }
          });
        }
      }
      if (!seat) return;
      particle.seat = seat.id; usedSeats.add(seat.id);
      particle.x = seat.x * 100; particle.y = seat.y * 100;
      particle.angle = (random(key + ':angle') - .5) * (descriptor.arrangement === 'grouped' ? 10 : particle.productPhoto ? 12 : 150);
      if (descriptor.arrangement !== 'grouped' && descriptor.layout === 'tray' && !particle.productPhoto && seat.clearance < seat.width * descriptor.ratio * .72) particle.angle = seat.edgeAngle + (random(key + ':edge-angle') - .5) * 14;
      var width = descriptor.edgeOcclusion ? seat.width : descriptor.layout === 'tray' || seat.finish ? fitFootprint(seat, particle.angle, descriptor.ratio, descriptor.bounds, 1).width : seat.width;
      var sizeVariation = descriptor.layout === 'tray' ? .95 + random(key + ':size') * .05 : .90 + random(key + ':size') * .10;
      particle.width = width * 100 * sizeVariation;
      particle.footprintWidth = seat.width * 100 * sizeVariation;
      particle.finish = !!seat.finish;
      particle.depth = random(key + ':depth');
      particle.z = 1 + Math.round(particle.depth * 20 + particle.y * .7);
    });
    particles = particles.filter(function (particle) { return Number.isFinite(particle.x); });
    return {
      package: descriptor, items: items, particles: particles,
      layoutKey: layoutKey, seed: seed,
      totalQuantity: total, visibleQuantity: visibleQuantity, capacity: capacity || null,
      fillRatio: ratio, maxSprites: maxSprites,
      missingImageCount: items.length - visible.length,
      usesProductPhotos: visible.some(function (item) { return item.productPhoto; }),
      symbolicPackage: descriptor.symbolic
    };
  }

  function cssUrl(url) { return url ? 'url(' + JSON.stringify(url) + ')' : 'none'; }
  function setMask(element, url, clip) {
    element.style.maskImage = cssUrl(url);
    element.style.webkitMaskImage = cssUrl(url);
    element.style.clipPath = url ? 'none' : clip || 'none';
  }
  function boundsClip(bounds) {
    // Bounds constrain particle centres, not their edges. Custom photos without
    // an explicit mask/polygon must also clip the complete sprite area.
    return 'inset(' + [bounds.y, Math.max(0, 1 - bounds.x - bounds.width),
      Math.max(0, 1 - bounds.y - bounds.height), bounds.x]
      .map(function (value) { return (value * 100).toFixed(4) + '%'; }).join(' ') + ')';
  }
  function glyphMask(doc, glyph, ratio) {
    if (!glyph) return '';
    try {
      var canvas = doc.createElement('canvas');
      canvas.width = Math.round(400 * ratio); canvas.height = 400;
      var context = canvas.getContext('2d');
      if (!context) return '';
      context.font = '900 380px Arial, sans-serif';
      var width = context.measureText(glyph).width;
      var size = Math.min(380, 380 * (canvas.width * 0.9) / Math.max(1, width));
      context.font = '900 ' + size + 'px Arial, sans-serif';
      context.textAlign = 'center'; context.textBaseline = 'middle'; context.fillStyle = '#000';
      context.fillText(glyph, canvas.width / 2, 205);
      return canvas.toDataURL('image/png');
    } catch (_) { return ''; }
  }
  function mount(container, options) {
    if (!container || !container.ownerDocument || typeof container.appendChild !== 'function') throw new TypeError('A preview container element is required.');
    if (instances.has(container)) { var mounted = instances.get(container); mounted.update(options || {}); return mounted; }
    var doc = container.ownerDocument;
    var win = doc.defaultView || (typeof window === 'object' ? window : null);
    var origin = win && win.location ? win.location.origin : 'https://preview.invalid';
    var config = Object.assign({}, options || {}, { origin: origin });
    var disposed = false, initialRender = true, updating = false, currentPlan, packageKey = '', motionQuery;
    var nodes = new Map(), retiring = new Map(), removalTimers = new Set(), currentSeats = new Map();
    var flightGeneration = 0, nextLaunchAt = 0;
    var failedImages = new Set(), packageFailed = false, frontState = 'none', frontTimer = null;
    var maskState = 'none', maskLoader = null, maskTimer = null, maskGeneration = 0;
    var sizeObserver = null, fittedWidth = null, fittedHeight = null;
    var lidState = 'closed', lidReady = false, lidFailed = false, lidAnimation = null, lidTimer = null, lidTarget = false;
    var openFrontReady = false, openFrontFailed = false, openFrontTimer = null;
    var setTimer = win && win.setTimeout ? win.setTimeout.bind(win) : setTimeout;
    var clearTimer = win && win.clearTimeout ? win.clearTimeout.bind(win) : clearTimeout;
    var now = function () { return win && win.performance && typeof win.performance.now === 'function' ? win.performance.now() : Date.now(); };
    var element = function (tag, className, parent) {
      var node = doc.createElement(tag); node.className = className;
      if (parent) parent.appendChild(node);
      return node;
    };
    if (!doc.getElementById(stylesheetId)) {
      var stylesheet = element('style', ''); stylesheet.id = stylesheetId; stylesheet.textContent = styles;
      (doc.head || doc.documentElement).appendChild(stylesheet);
    }
    var root = element('div', 'ss-candy-preview', container);
    var scene = element('div', 'ss-candy-preview__scene', root);
    scene.setAttribute('aria-hidden', 'true');
    var vessel = element('div', 'ss-candy-preview__vessel', scene);
    var shell = element('div', 'ss-candy-preview__shell', vessel);
    var back = element('img', 'ss-candy-preview__image', vessel);
    var depth = element('div', 'ss-candy-preview__depth', vessel);
    var content = element('div', 'ss-candy-preview__content', vessel);
    var front = element('img', 'ss-candy-preview__image ss-candy-preview__image--front', vessel);
    var openFront = element('img', 'ss-candy-preview__image ss-candy-preview__image--front ss-candy-preview__open-front', vessel);
    var frontWall = element('img', 'ss-candy-preview__image ss-candy-preview__image--front ss-candy-preview__front-wall', vessel);
    var frontSurface = element('img', 'ss-candy-preview__image ss-candy-preview__image--front ss-candy-preview__front-surface', vessel);
    var frontDetail = element('img', 'ss-candy-preview__image ss-candy-preview__image--front ss-candy-preview__front-detail', vessel);
    var sticker = element('div', 'ss-package-sticker', vessel);
    var stickerLogo = element('img', 'ss-package-sticker__logo', sticker);
    stickerLogo.alt = ''; stickerLogo.draggable = false;
    var stickerText = element('span', 'ss-package-sticker__text', sticker);
    stickerText.textContent = 'WUNSCHPRODUKT';
    sticker.hidden = true;
    // A sibling of the clipped fill: entry arcs stay visible above the opening.
    var flightLayer = element('div', 'ss-candy-preview__flight', vessel);
    var lid = element('img', 'ss-candy-preview__image ss-candy-preview__lid', vessel);
    var status = element('p', 'ss-candy-preview__status', root);
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    [back, front, openFront, frontWall, frontSurface, frontDetail, lid].forEach(function (img) { img.alt = ''; img.draggable = false; img.decoding = 'async'; img.hidden = true; });

    function fitVessel() {
      if (disposed || !currentPlan) return;
      // Fit both dimensions together. A fixed height plus max-width let flex
      // shrink only the width in narrow zoom dialogs and distorted every layer.
      // Local client sizes also avoid double-scaling a transformed ancestor.
      var availableWidth = Math.max(0, number(scene.clientWidth, 0)) * .94;
      var availableHeight = Math.max(0, number(scene.clientHeight, 0));
      var ratio = currentPlan.package.ratio;
      var width = Math.min(availableWidth, availableHeight * ratio);
      var height = width / ratio;
      if (width !== fittedWidth) { vessel.style.width = width.toFixed(4) + 'px'; fittedWidth = width; }
      if (height !== fittedHeight) { vessel.style.height = height.toFixed(4) + 'px'; fittedHeight = height; }
    }
    function labels() {
      var supplied = config.labels || {}, result = {};
      Object.keys(defaultLabels).forEach(function (key) {
        result[key] = text(supplied[key], '').trim() || defaultLabels[key];
      });
      return result;
    }
    function reduced() { return config.reducedMotion === true || !!(motionQuery && motionQuery.matches); }
    function refreshStatus() {
      if (disposed || !currentPlan) return;
      var copy = labels(), parts = [], emptyMessage = false;
      if (currentPlan.symbolicPackage) parts.push(text(copy.symbolic, defaultLabels.symbolic));
      if (packageFailed) parts.push(text(copy.packageMissing, defaultLabels.packageMissing));
      if (frontState === 'loading') parts.push(copy.maskLoading);
      if (maskState === 'loading') parts.push(copy.maskLoading);
      else if (maskState === 'failed') parts.push(copy.maskMissing);
      else if (!currentPlan.totalQuantity) { parts.push(text(copy.empty, defaultLabels.empty)); emptyMessage = true; }
      // Keep this live region for empty/error states, not a repeated routine
      // caption. Source/illustrative metadata remains available on the root.
      var missing = currentPlan.missingImageCount + currentPlan.items.filter(function (item) { return failedImages.has(item.url); }).length;
      if (missing) parts.push(text(copy.missing, defaultLabels.missing));
      status.textContent = parts.filter(Boolean).join(' · ');
      status.setAttribute('data-status-kind', !status.textContent ? 'none' : parts.length === 1 && emptyMessage ? 'empty' : 'message');
      root.setAttribute('data-empty', String(!currentPlan.totalQuantity));
      root.setAttribute('data-illustrative', 'true');
      root.setAttribute('data-product-photos', String(currentPlan.usesProductPhotos));
      root.setAttribute('data-missing-images', String(missing));
      root.setAttribute('data-reduced-motion', String(reduced()));
      root.setAttribute('data-mask-state', maskState);
      root.setAttribute('data-front-state', frontState);
    }
    function stopMotion(record) {
      if (!record.animation) return;
      record.animation.onfinish = record.animation.oncancel = null;
      record.animation.cancel(); record.animation = null;
    }
    function positionParticle(record) {
      var particle = record.particle, node = record.node;
      var descriptor = currentPlan.package, aspect = record.imageAspect || 1;
      var renderAngle = particle.angle;
      var dimensions = { width: particle.width / 100, height: particle.width / 100 * descriptor.ratio };
      // Preserve each approved cutout's natural proportions. Equal target area
      // avoids shrinking a long worm into the skinny middle of a square tile.
      // The complete, rotated rectangle is fitted before the first flight and
      // its centre never moves when its pixels finish loading.
      if (!particle.productPhoto && aspect !== 1 && currentSeats.has(particle.seat)) {
        var templateSeat = currentSeats.get(particle.seat);
        // A portrait cutout's long axis is Y, not X: turn the long side along
        // the tray wall instead of pointing a worm through it and shrinking it.
        if (descriptor.arrangement !== 'grouped' && descriptor.layout === 'tray' && aspect < .7 && templateSeat.clearance < templateSeat.width * descriptor.ratio * .72) renderAngle -= 90;
        var signature = JSON.stringify([currentPlan.layoutKey, particle.x, particle.y, renderAngle, particle.footprintWidth, aspect]);
        if (record.fitSignature !== signature) {
          var seat = Object.assign({}, templateSeat, { width: particle.footprintWidth / 100 });
          record.fitted = descriptor.edgeOcclusion
            ? { width: seat.width * Math.sqrt(aspect), height: seat.width * descriptor.ratio / Math.sqrt(aspect) }
            : fitFootprint(seat, renderAngle, descriptor.ratio, descriptor.bounds, aspect);
          record.fitSignature = signature;
        }
        dimensions = record.fitted;
      }
      node.style.left = particle.x.toFixed(4) + '%';
      node.style.top = particle.y.toFixed(4) + '%';
      node.style.width = (dimensions.width * 100).toFixed(4) + '%';
      node.style.height = (dimensions.height * 100).toFixed(4) + '%';
      node.style.zIndex = String(particle.z);
      record.renderAngle = renderAngle;
      node.style.setProperty('--ss-piece-angle', renderAngle.toFixed(2) + 'deg');
      node.style.setProperty('--ss-piece-shadow', (.7 + particle.depth * 1.5).toFixed(2) + 'px');
      syncDepth(record);
    }
    function syncDepth(record) {
      var descriptor = currentPlan.package;
      if (!descriptor.depthPolygon || record.phase !== 'landed' || failedImages.has(record.particle.url)) {
        if (record.depthNode) { removeNode(record.depthNode); record.depthNode = null; }
        return;
      }
      // The same real piece, projected behind the transparent front wall. This
      // adds no ingredient or logical particle and has its own hard wall mask.
      if (!record.depthNode) {
        record.depthNode = element('img', 'ss-candy-preview__depth-piece', depth);
        record.depthNode.alt = ''; record.depthNode.draggable = false; record.depthNode.decoding = 'async';
        var created = record.depthNode;
        created.onerror = function () { if (!disposed && nodes.get(record.key) === record && record.depthNode === created) failIngredient(record.particle.url); };
        record.depthNode.src = record.particle.url;
      }
      var node = record.depthNode;
      node.style.width = (parseFloat(record.node.style.width) * descriptor.depthPieceScale).toFixed(4) + '%';
      node.style.height = (parseFloat(record.node.style.height) * descriptor.depthPieceScale).toFixed(4) + '%';
      var x = record.particle.x / 100 + descriptor.depthOffset.x;
      var y = record.particle.y / 100 + descriptor.depthOffset.y;
      if (descriptor.depthMode === 'contour') {
        var sourceSpan = verticalSpan(record.particle.x / 100, descriptor.fillPolygon);
        var wallSpan = verticalSpan(x, descriptor.depthPolygon);
        if (sourceSpan && wallSpan) {
          // A heart's front wall is a V-shaped band, not a parallel y-offset.
          // Project the same surface column into its measured glass depth so
          // both sloped sides and the tip fill continuously. No new ingredients
          // or extra copies: each already bounded source retains one image.
          var along = clamp((record.particle.y / 100 - sourceSpan.top) / Math.max(.001, sourceSpan.bottom - sourceSpan.top), 0, 1);
          y = wallSpan.top + (wallSpan.bottom - wallSpan.top) * (.08 + along * .84);
        }
      }
      node.style.left = (x * 100).toFixed(4) + '%';
      node.style.top = (y * 100).toFixed(4) + '%';
      node.style.zIndex = record.node.style.zIndex;
      node.style.setProperty('--ss-piece-angle', record.renderAngle.toFixed(2) + 'deg');
    }
    function syncLayerVisibility() {
      var blocked = frontState === 'loading' || frontState === 'failed' || maskState === 'loading' || maskState === 'failed';
      content.hidden = blocked; flightLayer.hidden = blocked;
      depth.hidden = blocked || !currentPlan.package.depthPolygon;
      if (currentPlan.package.depthPolygon && currentPlan.package.depthFrontOpacity < 1) {
        // Preserve the same actual front-wall pixels. Only their alpha within
        // the authored glass patch changes; opaque rim and ribbon stay intact.
        var wallActive = !blocked && currentPlan.totalQuantity > 0;
        frontWall.hidden = !wallActive;
        front.style.clipPath = wallActive ? currentPlan.package.frontClip : currentPlan.package.frontBaseClip || 'none';
      } else frontWall.hidden = true;
      var surfaceActive = !blocked && currentPlan.totalQuantity > 0 && !!currentPlan.package.surfacePolygon;
      frontSurface.hidden = !surfaceActive;
      frontDetail.hidden = !surfaceActive || !currentPlan.package.frontDetailClip;
    }
    function failIngredient(url) {
      failedImages.add(url);
      nodes.forEach(function (record) {
        if (record.particle.url !== url) return;
        stopMotion(record); record.node.hidden = true;
        if (record.depthNode) { removeNode(record.depthNode); record.depthNode = null; }
      });
      syncLid(); refreshStatus();
    }
    function phase(record, value) {
      record.phase = value; record.node.setAttribute('data-flight-phase', value);
    }
    function land(record) {
      stopMotion(record);
      if (disposed || nodes.get(record.key) !== record) return;
      content.appendChild(record.node); phase(record, 'landed');
      record.node.classList.remove('is-in-flight'); record.node.classList.add('is-visible');
      positionParticle(record);
      syncLid();
    }
    function stopLidMotion() {
      if (!lidAnimation) return;
      lidAnimation.onfinish = lidAnimation.oncancel = null;
      lidAnimation.cancel(); lidAnimation = null;
    }
    function bodyClip(descriptor) {
      // A real open-neck patch replaces only its authored top strip. Never
      // simulate an opening by amputating the cap from the closed photograph.
      var active = lidReady && openFrontReady && !lidFailed && !openFrontFailed && descriptor.lid;
      var cut = active ? descriptor.openFrontBounds.height * 100 : 0;
      back.style.clipPath = cut ? 'inset(' + cut.toFixed(4) + '% 0 0 0)' : descriptor.imageClip || 'none';
      front.style.clipPath = cut ? back.style.clipPath : descriptor.frontClip || 'none';
      openFront.hidden = !active;
      lid.hidden = !active;
    }
    function setLidOpen(open, instant) {
      var descriptor = currentPlan.package.lid;
      if (!descriptor || !lidReady || !openFrontReady || lidFailed || openFrontFailed) return;
      if (lidTarget === open && (lidAnimation || lidState === (open ? 'open' : 'closed'))) return;
      var previous = lid.style.transform || 'translate(0%,0%) rotateY(0deg) rotate(0deg)';
      if (lidAnimation && win && typeof win.getComputedStyle === 'function') previous = win.getComputedStyle(lid).transform || previous;
      stopLidMotion();
      lidTarget = open;
      var transform = open ? 'translate(' + descriptor.open.x * 100 + '%,' + descriptor.open.y * 100 + '%) rotateY(360deg) rotate(' + descriptor.open.angle + 'deg)' : 'translate(0%,0%) rotateY(0deg) rotate(0deg)';
      lid.style.transform = transform;
      function finished() {
        lidState = open ? 'open' : 'closed'; root.setAttribute('data-lid-state', lidState);
        if (open) nodes.forEach(startFlight);
      }
      if (instant || reduced() || typeof lid.animate !== 'function') { finished(); return; }
      lidState = open ? 'opening' : 'closing'; root.setAttribute('data-lid-state', lidState);
      var generation = flightGeneration;
      try {
        var twist = 'translate(0%,' + (open ? -2 : -3) + '%) rotateY(' + (open ? 180 : 180) + 'deg) rotate(0deg)';
        var animation = lid.animate([{ transform: previous, offset: 0 }, { transform: twist, offset: open ? .42 : .58 }, { transform: transform, offset: 1 }], { duration: open ? 340 : 360, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'both' });
        lidAnimation = animation;
        animation.onfinish = function () {
          if (disposed || generation !== flightGeneration || lidAnimation !== animation) return;
          stopLidMotion(); finished();
        };
      } catch (_) { finished(); }
    }
    function syncLid() {
      if (disposed || updating || !currentPlan || !currentPlan.package.lid || !lidReady || !openFrontReady || lidFailed || openFrontFailed) return;
      var pending = Array.from(nodes.values()).some(function (record) { return record.phase !== 'landed' && !record.settledInitially && !failedImages.has(record.particle.url); });
      var open = currentPlan.totalQuantity > 0 && (currentPlan.fillRatio < 1 || pending);
      setLidOpen(open, reduced() || initialRender && config.animateInitial === false);
    }
    function setLidImage(descriptor) {
      stopLidMotion();
      if (lidTimer !== null) { clearTimer(lidTimer); lidTimer = null; }
      if (openFrontTimer !== null) { clearTimer(openFrontTimer); openFrontTimer = null; }
      openFront.onload = openFront.onerror = null; openFrontReady = false; openFrontFailed = false; openFront.hidden = true;
      lid.onload = lid.onerror = null; lidReady = false; lidFailed = false; lidTarget = false; lidState = 'closed';
      lid.hidden = true; lid.style.transform = 'translate(0%,0%) rotateY(0deg) rotate(0deg)';
      root.setAttribute('data-lid-state', descriptor.lid ? 'loading' : descriptor.openingPending ? 'unavailable' : 'none');
      bodyClip(descriptor);
      if (!descriptor.lid) { lid.removeAttribute('src'); openFront.removeAttribute('src'); return; }
      var generation = flightGeneration, bounds = descriptor.lid.bounds;
      lid.style.clipPath = boundsClip(bounds);
      lid.style.setProperty('--ss-lid-origin', (bounds.x + bounds.width / 2) * 100 + '% ' + (bounds.y + bounds.height) * 100 + '%');
      openFront.style.clipPath = boundsClip(descriptor.openFrontBounds);
      function finishOpen(loaded) {
        if (disposed || generation !== flightGeneration || openFrontReady || openFrontFailed) return;
        if (openFrontTimer !== null) { clearTimer(openFrontTimer); openFrontTimer = null; }
        openFront.onload = openFront.onerror = null; openFrontReady = loaded; openFrontFailed = !loaded;
        if (!loaded) { packageFailed = true; root.setAttribute('data-lid-state', 'failed'); }
        bodyClip(descriptor); syncLid(); nodes.forEach(startFlight); refreshStatus();
      }
      openFront.onload = function () { finishOpen(openFront.naturalWidth > 0 && openFront.naturalHeight > 0); };
      openFront.onerror = function () { finishOpen(false); };
      openFrontTimer = setTimer(function () { finishOpen(false); }, 15000);
      openFront.src = descriptor.openFrontUrl;
      if (openFront.complete && openFront.naturalWidth > 0 && openFront.naturalHeight > 0) finishOpen(true);
      function finish(loaded) {
        if (disposed || generation !== flightGeneration || lidReady || lidFailed) return;
        if (lidTimer !== null) { clearTimer(lidTimer); lidTimer = null; }
        lid.onload = lid.onerror = null;
        lidReady = loaded; lidFailed = !loaded; lid.hidden = !loaded;
        if (!loaded) packageFailed = true;
        bodyClip(descriptor);
        root.setAttribute('data-lid-state', loaded && !openFrontFailed ? openFrontReady ? 'closed' : 'loading' : 'failed');
        syncLid(); nodes.forEach(startFlight); refreshStatus();
      }
      lid.onload = function () { finish(lid.naturalWidth > 0 && lid.naturalHeight > 0); };
      lid.onerror = function () { finish(false); };
      lidTimer = setTimer(function () { finish(false); }, 15000);
      lid.src = descriptor.lid.imageUrl;
      if (lid.complete && lid.naturalWidth > 0 && lid.naturalHeight > 0) finish(true);
    }
    function motionFrame(x, y, angle, scale, opacity, offset) {
      return { left: x.toFixed(4) + '%', top: y.toFixed(4) + '%',
        transform: 'translate(-50%,-50%) rotate(' + angle.toFixed(2) + 'deg) scale(' + scale + ')', opacity: opacity, offset: offset };
    }
    function play(record, keyframes, duration, delay, complete) {
      var generation = flightGeneration;
      try {
        var animation = record.node.animate(keyframes, { duration: duration, delay: delay, easing: 'linear', fill: 'both' });
        record.animation = animation;
        animation.onfinish = function () {
          if (disposed || generation !== flightGeneration || nodes.get(record.key) !== record || record.animation !== animation) return;
          stopMotion(record); complete();
        };
      } catch (_) { land(record); }
    }
    function fall(record, entry) {
      if (disposed || nodes.get(record.key) !== record) return;
      if (reduced()) { land(record); return; }
      var particle = record.particle, distance = Math.max(0, particle.y - entry.y), finalAngle = record.renderAngle == null ? particle.angle : record.renderAngle;
      content.appendChild(record.node); phase(record, 'falling');
      // Accelerate under gravity, then settle. From the mouth onward every frame
      // is clipped by the existing package mask/polygon/bounds.
      play(record, [
        motionFrame(entry.x, entry.y, finalAngle - 80, .90, 1, 0),
        motionFrame(entry.x + (particle.x - entry.x) * .35, entry.y + distance * .18, finalAngle - 32, .98, 1, .42),
        motionFrame(particle.x, particle.y, finalAngle + 6, .94, 1, .84),
        motionFrame(particle.x, particle.y - Math.min(1.5, distance * .04), finalAngle - 3, 1.03, 1, .93),
        motionFrame(particle.x, particle.y, finalAngle, 1, 1, 1)
      ], 180 + distance * 3, 0, function () { land(record); });
    }
    function startFlight(record) {
      if (disposed || nodes.get(record.key) !== record || record.animation || record.phase === 'landed') return;
      if (failedImages.has(record.particle.url)) { record.node.hidden = true; return; }
      if (maskState === 'loading' || maskState === 'failed' || frontState === 'loading' || frontState === 'failed') { phase(record, 'waiting-mask'); return; }
      // Latch the initial choice on each record so a late image/mask load in a
      // newly opened zoom view cannot replay the already selected whole mix.
      if (record.settledInitially || reduced() || typeof record.node.animate !== 'function') { land(record); return; }
      if (!record.ready) { phase(record, 'waiting-image'); return; }
      var descriptor = currentPlan.package, particle = record.particle, finalAngle = record.renderAngle == null ? particle.angle : record.renderAngle;
      if (descriptor.openingPending || descriptor.lid && (lidFailed || openFrontFailed)) { land(record); return; }
      if (descriptor.lid && (!lidReady || !openFrontReady || lidState !== 'open')) { phase(record, 'waiting-lid'); syncLid(); return; }
      var entry = { x: descriptor.opening.x * 100, y: descriptor.opening.y * 100 };
      var side = random(record.key + ':side') < .5 ? -1 : 1;
      var startX = clamp(entry.x + side * (7 + random(record.key + ':entry') * 9), 5, 95);
      var startY = Math.max(-3, entry.y - 22), peakY = startY - 3;
      var angle = side * (70 + random(record.key + ':turn') * 100);
      var stamp = now();
      // A full surprise mix still enters piece by piece, but its entire queue
      // starts within 1.8 seconds instead of making the last sorts wait 5+ s.
      nextLaunchAt = Math.min(Math.max(stamp, nextLaunchAt), stamp + Math.min(1800, currentPlan.maxSprites * 55));
      var delay = Math.max(0, nextLaunchAt - stamp);
      nextLaunchAt += Math.min(55, 1800 / Math.max(1, currentPlan.particles.length - 1));
      flightLayer.appendChild(record.node); phase(record, 'approach');
      record.node.classList.add('is-in-flight'); record.node.classList.add('is-visible');
      var frames = [], rise = (startY + entry.y) / 2 - peakY;
      // Sample one smooth parabolic arc rather than a few visibly angular
      // direction changes. Landing/masking still starts exactly at the mouth.
      for (var frame = 0; frame <= 16; frame += 1) {
        var progress = frame / 16;
        frames.push(motionFrame(
          startX + (entry.x - startX) * progress,
          startY + (entry.y - startY) * progress - 4 * rise * progress * (1 - progress),
          angle + (finalAngle - 80 - angle) * progress,
          1.15 + Math.sin(Math.PI * progress) * .1 - progress * .25,
          Math.min(1, progress / .06), progress
        ));
      }
      play(record, frames, 390 + random(record.key + ':duration') * 110, delay, function () { fall(record, entry); });
    }
    function motionChanged() {
      if (reduced()) {
        nodes.forEach(land);
        retiring.forEach(function (record) { clearTimer(record.timer); removalTimers.delete(record.timer); removeNode(record.node); });
        retiring.clear(); nextLaunchAt = 0;
        stopLidMotion();
        lidState = 'interrupted';
        syncLid();
      }
      refreshStatus();
    }
    function removeNode(node) {
      node.onload = null; node.onerror = null;
      if (node.parentNode) node.parentNode.removeChild(node);
    }
    function removeParticle(key, record) {
      nodes.delete(key);
      stopMotion(record);
      if (record.depthNode) { removeNode(record.depthNode); record.depthNode = null; }
      record.node.classList.remove('is-visible');
      if (reduced() || record.phase !== 'landed') { removeNode(record.node); return; }
      var timer = setTimer(function () {
        removalTimers.delete(timer); retiring.delete(key); removeNode(record.node);
      }, 190);
      record.timer = timer;
      retiring.set(key, record);
      removalTimers.add(timer);
    }
    function setPackageImage(img, url) {
      var generation = flightGeneration;
      img.onload = null; img.onerror = null;
      img.hidden = !url;
      if (!url) { img.removeAttribute('src'); return; }
      var confirmFront = img === front && (currentPlan.package.edgeOcclusion || !!currentPlan.package.depthPolygon);
      if (confirmFront) frontState = 'loading';
      function fail() {
        if (disposed || generation !== flightGeneration) return;
        img.hidden = true; packageFailed = true;
        if (confirmFront) {
          frontState = 'failed';
          if (frontTimer !== null) { clearTimer(frontTimer); frontTimer = null; }
          syncLayerVisibility();
        }
        refreshStatus();
      }
      img.onerror = fail;
      if (confirmFront) {
        img.onload = function () {
          if (disposed || generation !== flightGeneration || frontState !== 'loading') return;
          if (!(img.naturalWidth > 0 && img.naturalHeight > 0)) { fail(); return; }
          frontState = 'ready';
          if (frontTimer !== null) { clearTimer(frontTimer); frontTimer = null; }
          syncLayerVisibility(); nodes.forEach(startFlight); refreshStatus();
        };
        frontTimer = setTimer(fail, 15000);
      }
      img.src = url;
      if (confirmFront && img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) img.onload();
    }
    function cancelMaskLoad() {
      maskGeneration += 1;
      if (maskTimer !== null) { clearTimer(maskTimer); maskTimer = null; }
      if (maskLoader) {
        maskLoader.onload = maskLoader.onerror = null;
        maskLoader.removeAttribute('src');
        maskLoader = null;
      }
    }
    function preloadMask(url) {
      // Match CSS masking's anonymous CORS request. A normal opaque <img> load
      // alone could succeed while the cross-origin CSS mask still fails.
      var loader = doc.createElement('img'), generation = maskGeneration;
      maskLoader = loader;
      maskState = 'loading';
      content.hidden = true;
      flightLayer.hidden = true;
      setMask(content, '', 'inset(100%)');
      loader.crossOrigin = 'anonymous';
      function finish(loaded) {
        if (disposed || generation !== maskGeneration || maskLoader !== loader) return;
        if (maskTimer !== null) { clearTimer(maskTimer); maskTimer = null; }
        loader.onload = loader.onerror = null;
        maskLoader = null;
        maskState = loaded ? 'ready' : 'failed';
        // Never replace a failed bespoke mask with an unbounded or invented
        // vessel silhouette. Keep the package photo and selected quantities.
        setMask(content, loaded ? url : '', loaded ? '' : 'inset(100%)');
        syncLayerVisibility();
        if (loaded) nodes.forEach(startFlight);
        refreshStatus();
      }
      loader.onload = function () { finish(loader.naturalWidth > 0 && loader.naturalHeight > 0); };
      loader.onerror = function () { finish(false); };
      maskTimer = setTimer(function () { finish(false); }, 15000);
      loader.src = url;
    }
    function renderPackage(descriptor) {
      var nextKey = JSON.stringify(descriptor);
      if (nextKey === packageKey) return;
      packageKey = nextKey; packageFailed = false;
      if (frontTimer !== null) { clearTimer(frontTimer); frontTimer = null; }
      frontState = 'none';
      flightGeneration += 1; nextLaunchAt = 0;
      nodes.forEach(land);
      retiring.forEach(function (record) { clearTimer(record.timer); removalTimers.delete(record.timer); removeNode(record.node); });
      retiring.clear();
      cancelMaskLoad();
      maskState = 'none';
      vessel.style.aspectRatio = String(descriptor.ratio);
      sticker.hidden = !descriptor.sticker;
      if (descriptor.sticker) {
        stickerLogo.src = descriptor.sticker.logoUrl;
        sticker.style.left = descriptor.sticker.bounds.x * 100 + '%';
        sticker.style.top = descriptor.sticker.bounds.y * 100 + '%';
        sticker.style.width = descriptor.sticker.bounds.width * 100 + '%';
        sticker.style.height = descriptor.sticker.bounds.height * 100 + '%';
      } else stickerLogo.removeAttribute('src');
      depth.style.clipPath = descriptor.depthClip || 'inset(100%)';
      depth.hidden = !descriptor.depthPolygon;
      root.setAttribute('data-shape', descriptor.shape);
      root.setAttribute('data-arrangement', descriptor.arrangement);
      var generatedMask = !descriptor.maskUrl && descriptor.symbolic && /^(letter|number)$/.test(descriptor.shape) ? glyphMask(doc, descriptor.glyph, descriptor.ratio) : '';
      shell.hidden = !descriptor.symbolic;
      setMask(shell, generatedMask, descriptor.clip);
      if (descriptor.maskUrl) preloadMask(descriptor.maskUrl);
      else {
        content.hidden = false;
        flightLayer.hidden = false;
        setMask(content, generatedMask, descriptor.fillClip || (descriptor.genericClip ? descriptor.clip : boundsClip(descriptor.bounds)));
      }
      setPackageImage(back, descriptor.imageUrl);
      back.style.clipPath = descriptor.imageClip || 'none';
      setPackageImage(front, descriptor.frontUrl);
      setPackageImage(frontWall, descriptor.depthPolygon && descriptor.depthFrontOpacity < 1 ? descriptor.frontUrl : '');
      frontWall.style.clipPath = descriptor.depthClip || 'inset(100%)';
      frontWall.style.opacity = String(descriptor.depthFrontOpacity);
      setPackageImage(frontSurface, descriptor.surfacePolygon ? descriptor.frontUrl : '');
      frontSurface.style.clipPath = descriptor.surfaceClip || 'inset(100%)';
      frontSurface.style.opacity = String(descriptor.surfaceFrontOpacity);
      setPackageImage(frontDetail, descriptor.frontDetailClip ? descriptor.frontUrl : '');
      frontDetail.style.clipPath = descriptor.frontDetailClip || 'inset(100%)';
      setLidImage(descriptor);
      syncLayerVisibility();
    }
    function update(patch) {
      if (disposed) return api;
      patch = patch && typeof patch === 'object' ? patch : {};
      config = Object.assign({}, config, patch, { origin: origin });
      updating = true;
      var previousPlan = currentPlan;
      currentPlan = createPlan(config, previousPlan);
      currentSeats = new Map(layoutSeats(currentPlan.package, currentPlan.maxSprites, currentPlan.seed).map(function (seat) { return [seat.id, seat]; }));
      var changedPackage = !!previousPlan && JSON.stringify(currentPlan.package) !== JSON.stringify(previousPlan.package);
      renderPackage(currentPlan.package);
      fitVessel();
      var wanted = new Set(currentPlan.particles.map(function (particle) { return particle.key; }));
      nodes.forEach(function (record, key) { if (!wanted.has(key)) removeParticle(key, record); });
      if (!nodes.size) nextLaunchAt = 0;
      currentPlan.particles.forEach(function (particle) {
        var record = nodes.get(particle.key);
        if (!record && retiring.has(particle.key)) {
          record = retiring.get(particle.key);
          retiring.delete(particle.key); clearTimer(record.timer); removalTimers.delete(record.timer);
          nodes.set(particle.key, record);
          record.node.classList.add('is-visible');
        }
        if (!record) {
          var img = element('img', 'ss-candy-preview__sprite', content);
          img.alt = ''; img.draggable = false; img.decoding = 'async';
          record = { key: particle.key, node: img, particle: particle, phase: 'new', animation: null, ready: false,
            settledInitially: initialRender && config.animateInitial === false || changedPackage && previousPlan.totalQuantity > 0 };
          nodes.set(particle.key, record);
          img.onerror = function () {
            if (disposed || nodes.get(particle.key) !== record) return;
            failIngredient(particle.url);
          };
          img.onload = function () {
            if (disposed || nodes.get(particle.key) !== record) return;
            if (!(img.naturalWidth > 0 && img.naturalHeight > 0)) { img.onerror(); return; }
            record.imageAspect = clamp(img.naturalWidth / img.naturalHeight, .05, 20);
            record.ready = true; positionParticle(record); startFlight(record);
          };
          img.src = particle.url;
          img.hidden = failedImages.has(particle.url);
          record.ready = !!(img.complete && img.naturalWidth > 0 && img.naturalHeight > 0);
          if (record.ready) record.imageAspect = clamp(img.naturalWidth / img.naturalHeight, .05, 20);
        }
        record.particle = particle;
        positionParticle(record);
        startFlight(record);
      });
      // Exit animations are bounded too, even during rapid add/remove sequences.
      while (retiring.size && nodes.size + retiring.size > currentPlan.maxSprites * 2) {
        var oldest = retiring.entries().next().value;
        clearTimer(oldest[1].timer); removalTimers.delete(oldest[1].timer);
        removeNode(oldest[1].node); retiring.delete(oldest[0]);
      }
      updating = false;
      syncLayerVisibility();
      syncLid();
      if (reduced()) motionChanged();
      else refreshStatus();
      initialRender = false;
      return api;
    }
    function destroy() {
      if (disposed) return;
      disposed = true;
      flightGeneration += 1;
      if (sizeObserver) sizeObserver.disconnect();
      if (win && typeof win.removeEventListener === 'function') win.removeEventListener('resize', fitVessel);
      cancelMaskLoad();
      if (frontTimer !== null) { clearTimer(frontTimer); frontTimer = null; }
      stopLidMotion();
      if (lidTimer !== null) { clearTimer(lidTimer); lidTimer = null; }
      if (openFrontTimer !== null) { clearTimer(openFrontTimer); openFrontTimer = null; }
      removalTimers.forEach(clearTimer); removalTimers.clear();
      nodes.forEach(function (record) { stopMotion(record); removeNode(record.node); if (record.depthNode) removeNode(record.depthNode); }); nodes.clear();
      retiring.forEach(function (record) { removeNode(record.node); }); retiring.clear();
      [back, front, frontWall, frontSurface, frontDetail, openFront, lid].forEach(function (img) { img.onload = img.onerror = null; });
      if (motionQuery) {
        if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', motionChanged);
        else if (motionQuery.removeListener) motionQuery.removeListener(motionChanged);
      }
      if (root.parentNode) root.parentNode.removeChild(root);
      instances.delete(container);
    }
    var api = { update: update, destroy: destroy, getState: function () { return currentPlan; }, element: root };
    if (win && typeof win.matchMedia === 'function') {
      motionQuery = win.matchMedia('(prefers-reduced-motion: reduce)');
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', motionChanged);
      else if (motionQuery.addListener) motionQuery.addListener(motionChanged);
    }
    instances.set(container, api);
    if (win && typeof win.ResizeObserver === 'function') {
      try { sizeObserver = new win.ResizeObserver(fitVessel); sizeObserver.observe(scene); }
      catch (_) { if (sizeObserver) sizeObserver.disconnect(); sizeObserver = null; }
    }
    // Also supports older browsers without ResizeObserver. Normal updates
    // refit too, so showing a previously hidden preview never keeps a zero box.
    if (win && typeof win.addEventListener === 'function') win.addEventListener('resize', fitVessel);
    update({});
    return api;
  }
  function resolve(target) { return instances.get(target) || target; }
  return {
    mount: mount,
    update: function (target, patch) { var instance = resolve(target); return instance && typeof instance.update === 'function' ? instance.update(patch) : null; },
    destroy: function (target) { var instance = resolve(target); if (instance && typeof instance.destroy === 'function') instance.destroy(); },
    toItems: toItems,
    createPlan: createPlan,
    safeUrl: safeUrl
  };
});
